// @ts-nocheck
import { createReducer } from 'reduxsauce';
import produce from 'immer';
import { Types } from '../actions/cost_code';
import { Types as categoryTypes } from '../actions/category';

const initialState = {
  showCostCodeDrawer: false,
  formFields: {
    cost_code: null,
    description: null,
    category: null,
    sub_category: null,
    is_default: false,
    source: null,
  },
  confirmationModal: {
    show: false,
    costCodeId: null,
  },
  searchText: '',
  pagination: {
    totalPages: null,
    total: null,
    perPage: 25,
    pageNumber: 1,
  },
  noteModal: {
    show: false,
    noteId: null,
    notes: [],
    message: '',
    costCodeId: null,
    mode: null,
  },
  sort: {
    orderBy: 'updated_at',
    orderType: '',
  },
  costCodes: [],
  categoryOptions: [],
  subCategoryOptions: [],
  success: false,
};

const getCategoriesSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  return {
    ...state,
    categoryOptions: data.map((category) => ({
      ...category,
      label: category.name,
      value: category.id,
    })),
  };
};

const openCostCodeDrawer = (state) => ({
  ...state,
  showCostCodeDrawer: true,
});

const closeCostCodeDrawer = (state) => ({
  ...state,
  showCostCodeDrawer: false,
});

const resetFormFields = (state) => ({
  ...state,
  formFields: initialState.formFields,
});

const updateFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;
  return {
    ...state,
    formFields: {
      ...state.formFields,
      [name]: value,
    },
  };
};

const createCostCodeSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.default) {
    return {
      ...state,
      costCodes: produce(state.costCodes, (draft) => {
        const defaultCostCode = draft.find((costCode) => costCode.default);
        if (defaultCostCode) {
          defaultCostCode.default = false;
        }
        draft.push(data);
      }),
    };
  }

  return {
    ...state,
    costCodes: [...state.costCodes, data],
  };
};

const getCostCodesSuccess = (state, action) => {
  const {
    payload: { data, total_pages, total },
  } = action;
  return {
    ...state,
    costCodes: data,
    success: true,
    pagination: {
      ...state.pagination,
      totalPages: total_pages,
      total,
    },
  };
};

const editCostCode = (state, action) => ({
  ...state,
  formFields: { ...action.payload },
  showCostCodeDrawer: true,
});

const updateCostCodeSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data.default) {
    return {
      ...state,
      costCodes: produce(state.costCodes, (draft) => {
        const defaultCostCode = draft.find((costCode) => costCode.default);
        if (defaultCostCode) {
          defaultCostCode.default = false;
        }
        const index = draft.findIndex((costCode) => costCode.id === data.id);
        draft.splice(index, 1, data);
      }),
    };
  }

  return {
    ...state,
    costCodes: produce(state.costCodes, (draft) => {
      const index = draft.findIndex((costCode) => costCode.id === data.id);
      draft.splice(index, 1, data);
    }),
  };
};

const openConfirmationModal = (state, action) => {
  const {
    payload: { costCodeId },
  } = action;
  return {
    ...state,
    confirmationModal: {
      show: true,
      costCodeId,
    },
  };
};

const closeConfirmationModal = (state) => ({
  ...state,
  confirmationModal: initialState.confirmationModal,
});

const deleteCostCodeSuccess = (state) => {
  const {
    confirmationModal: { costCodeId },
  } = state;

  return {
    ...state,
    costCodes: state.costCodes.filter((costCode) => costCode.id !== costCodeId),
  };
};

const updateSearchText = (state, action) => {
  const {
    payload: { searchText },
  } = action;
  return {
    ...state,
    searchText,
  };
};

const updatePageNumber = (state, action) => {
  const {
    payload: { pageNumber },
  } = action;
  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageNumber,
    },
  };
};

const updatePerPage = (state, action) => {
  const clonedPagination = { ...state.pagination };

  clonedPagination.perPage = action.payload.perPage;
  if (
    clonedPagination.perPage >= clonedPagination.total ||
    clonedPagination.pageNumber >= clonedPagination.totalPages
  ) {
    clonedPagination.pageNumber = 1;
  }

  return {
    ...state,
    pagination: clonedPagination,
  };
};

const openNoteModal = (state, action) => {
  const {
    payload: { costCodeId, notes },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      show: true,
      costCodeId,
      notes,
    },
  };
};

const closeNoteModal = (state) => ({
  ...state,
  noteModal: initialState.noteModal,
});

const updateNoteMessage = (state, action) => {
  const {
    payload: { message },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      message,
    },
  };
};

const createNoteSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const {
    noteModal: { costCodeId },
  } = state;
  return {
    ...state,
    costCodes: produce(state.costCodes, (draft) => {
      const selectedCostCode = draft.find(
        (costCode) => costCode.id === costCodeId,
      );
      selectedCostCode.notes.push(data);
    }),
  };
};

const editNote = (state, action) => {
  const {
    payload: { noteId, message, mode },
  } = action;

  return {
    ...state,
    noteModal: {
      ...state.noteModal,
      noteId,
      message,
      mode,
      notes: [],
    },
  };
};

const updateNoteSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  const {
    noteModal: { noteId, costCodeId },
  } = state;

  return {
    ...state,
    costCodes: produce(state.costCodes, (draft) => {
      const selectedCostCode = draft.find(
        (costCode) => costCode.id === costCodeId,
      );

      const index = selectedCostCode.notes.findIndex(
        (note) => note.id === noteId,
      );
      selectedCostCode.notes.splice(index, 1, data);
    }),
  };
};

const deleteNoteSuccess = (state, action) => {
  const {
    payload: { noteId },
  } = action;
  const {
    noteModal: { costCodeId },
  } = state;

  return {
    ...state,
    costCodes: produce(state.costCodes, (draft) => {
      const selectedCostCode = draft.find(
        (costCode) => costCode.id === costCodeId,
      );

      const index = selectedCostCode.notes.findIndex(
        (note) => note.id === noteId,
      );
      selectedCostCode.notes.splice(index, 1);
    }),
    noteModal: {
      ...state.noteModal,
      notes: state.noteModal.notes.filter((note) => note.id !== noteId),
    },
  };
};

export const updateSortFields = (state, action) => ({
  ...state,
  sort: action.payload,
});

const updateSubCategoryOptions = (state, action) => {
  const {
    payload: { categoryId },
  } = action;

  const selectedCategory = state.categoryOptions.find(
    (category) => category.id === categoryId,
  );

  return {
    ...state,
    subCategoryOptions: selectedCategory
      ? selectedCategory.children.map((category) => ({
          ...category,
          label: category.name,
          value: category.id,
        }))
      : [],
  };
};

const costCodeReducer = createReducer(initialState, {
  [categoryTypes.GET_CATEGORIES_SUCCESS]: getCategoriesSuccess,
  [Types.OPEN_COST_CODE_DRAWER]: openCostCodeDrawer,
  [Types.CLOSE_COST_CODE_DRAWER]: closeCostCodeDrawer,
  [Types.RESET_FORM_FIELDS]: resetFormFields,
  [Types.UPDATE_FORM_FIELD]: updateFormField,
  [Types.CREATE_COST_CODE_SUCCESS]: createCostCodeSuccess,
  [Types.GET_COST_CODES_SUCCESS]: getCostCodesSuccess,
  [Types.EDIT_COST_CODE]: editCostCode,
  [Types.UPDATE_COST_CODE_SUCCESS]: updateCostCodeSuccess,
  [Types.OPEN_CONFIRMATION_MODAL]: openConfirmationModal,
  [Types.CLOSE_CONFIRMATION_MODAL]: closeConfirmationModal,
  [Types.DELETE_COST_CODE_SUCCESS]: deleteCostCodeSuccess,
  [Types.UPDATE_SEARCH_TEXT]: updateSearchText,
  [Types.UPDATE_PAGE_NUMBER]: updatePageNumber,
  [Types.UPDATE_PER_PAGE]: updatePerPage,
  [Types.OPEN_NOTE_MODAL]: openNoteModal,
  [Types.CLOSE_NOTE_MODAL]: closeNoteModal,
  [Types.UPDATE_NOTE_MESSAGE]: updateNoteMessage,
  [Types.CREATE_NOTE_SUCCESS]: createNoteSuccess,
  [Types.EDIT_NOTE]: editNote,
  [Types.UPDATE_NOTE_SUCCESS]: updateNoteSuccess,
  [Types.DELETE_NOTE_SUCCESS]: deleteNoteSuccess,
  [Types.UPDATE_SORT_FIELDS]: updateSortFields,
  [Types.UPDATE_SUB_CATEGORY_OPTIONS]: updateSubCategoryOptions,
});

export default costCodeReducer;
